const recapI18n = {
  "fr": {
    "recap": {
      "title": "Récapitulatif",
      "brand": {
        "other": "autre"
      },
      "count": {
        "devices": "Appareils",
        "parts": "Pièces détachées",
        "totalItems": "Total pièces"
      },
      "total": "Total",
      "actions": {
        "validate": "Valider",
        "viewDetail": "Voir le détail",
        "clear": "Vider le panier",
        "removeSelection": "Supprimer la sélection",
        "close": "Fermer"
      },
      "detail": {
        "title": "Détail du panier",
        "empty": "Aucune ligne.",
        "aria": "détail panier"
      },
      "table": {
        "article": "Article",
        "unitPrice": "PU (€)",
        "qty": "Qté",
        "total": "Total (€)"
      },
      "kind": {
        "device": "Appareil complet",
        "part": "Pièce détachée"
      },
      "labels": {
        "screen": "Écran",
        "part": "Pièce",
        "battery": "Batterie",
        "camera": "Caméra",
        "speaker": "Haut-parleur",
        "microphone": "Micro",
        "chargingConnector": "Connecteur de charge",
        "button": "Bouton",
        "vibrator": "Vibreur",
        "micro": "Micro",
        "charging": "Connecteur de charge"
      },
      "validation": {
        "minModelsTitle": "Quantité minimale d’écrans non atteinte",
        "minModelsBody": "Pour des raisons logistiques, un minimum de 15 écrans est requis par envoi. Merci d’ajouter quelques pièces supplémentaires à votre panier avant de poursuivre.",
        "minModelsCta": "Je continue"
      },
      "expertise": {
        "dialogTitle": "Préciser votre envoi",
        "dialogSubtitle": "Ces informations nous aident à préparer votre bordereau de transport (nombre de colis, estimation du poids, etc.).",
        "piecesLabel": "Nombre approximatif de pièces",
        "piecesPlaceholder": "Ex. 120",
        "weightKgLabel": "Poids approximatif (kg)",
        "weightKgPlaceholder": "Ex. 18",
        "parcelsLabel": "Nombre de colis",
        "parcelsPlaceholder": "Ex. 2",
        "minPiecesHint": "Pour des raisons logistiques, un minimum de 15 écrans est requis par envoi.",
        "weightHint": "Astuce : répartissez vos écrans sur plusieurs colis si vous approchez des 30 kg.",
        "globalHelper": "Pour des raisons logistiques, nous recommandons un maximum de 30 kg par colis. Indiquez simplement une estimation, nous ajusterons si besoin lors de la création du bordereau.",
        "cancel": "Retour",
        "confirm": "Valider et continuer"
      }
    }
  },
  "en": {
    "recap": {
      "title": "Summary",
      "brand": {
        "other": "other"
      },
      "count": {
        "devices": "Devices",
        "parts": "Spare parts",
        "totalItems": "Total items"
      },
      "total": "Total",
      "actions": {
        "validate": "Validate",
        "viewDetail": "View details",
        "clear": "Clear cart",
        "removeSelection": "Remove selection",
        "close": "Close"
      },
      "detail": {
        "title": "Cart details",
        "empty": "No items.",
        "aria": "cart details"
      },
      "table": {
        "article": "Item",
        "unitPrice": "Unit (€)",
        "qty": "Qty",
        "total": "Total (€)"
      },
      "kind": {
        "device": "Complete device",
        "part": "Spare part"
      },
      "labels": {
        "screen": "Screen",
        "part": "Part",
        "battery": "Battery",
        "camera": "Camera",
        "speaker": "Speaker",
        "microphone": "Microphone",
        "chargingConnector": "Charging connector",
        "button": "Taste",
        "vibrator": "Vibrationsmotor",
        "micro": "Microphone",
        "charging": "Charging connector"
      },
      "validation": {
        "minModelsTitle": "Minimum screen quantity not reached",
        "minModelsBody": "For logistical reasons, a minimum of 15 screens is required per shipment. Please add a few more items to your cart before proceeding.",
        "minModelsCta": "Continue"
      },
      "expertise": {
        "dialogTitle": "Add details about your shipment",
        "dialogSubtitle": "This information helps us prepare your shipping label (number of parcels, estimated weight, etc.).",
        "piecesLabel": "Approximate number of items",
        "piecesPlaceholder": "e.g. 120",
        "weightKgLabel": "Approximate weight (kg)",
        "weightKgPlaceholder": "e.g. 18",
        "parcelsLabel": "Number of parcels",
        "parcelsPlaceholder": "e.g. 2",
        "minPiecesHint": "For logistical reasons, a minimum of 15 screens is required per shipment.",
        "weightHint": "Tip: split your screens into multiple parcels if you are close to 30 kg.",
        "globalHelper": "For logistics reasons, we recommend a maximum of 30 kg per parcel. Just provide an estimate; we’ll adjust it if needed when generating the label.",
        "cancel": "Back",
        "confirm": "Save and continue"
      }
    }
  },
  "pl": {
    "recap": {
      "title": "Podsumowanie",
      "brand": {
        "other": "inne"
      },
      "count": {
        "devices": "Urządzenia",
        "parts": "Części zamienne",
        "totalItems": "Razem sztuk"
      },
      "total": "Suma",
      "actions": {
        "validate": "Zatwierdź",
        "viewDetail": "Zobacz szczegóły",
        "clear": "Wyczyść koszyk",
        "removeSelection": "Usuń wybór",
        "close": "Zamknij"
      },
      "detail": {
        "title": "Szczegóły koszyka",
        "empty": "Brak pozycji.",
        "aria": "szczegóły koszyka"
      },
      "table": {
        "article": "Pozycja",
        "unitPrice": "Cena j. (€)",
        "qty": "Ilość",
        "total": "Suma (€)"
      },
      "kind": {
        "device": "Urządzenie kompletne",
        "part": "Część zamienna"
      },
      "labels": {
        "screen": "Ekran",
        "part": "Część",
        "battery": "Bateria",
        "camera": "Aparat",
        "speaker": "Głośnik",
        "microphone": "Mikrofon",
        "chargingConnector": "Złącze ładowania",
        "button": "Przycisk",
        "vibrator": "Wibrator",
        "micro": "Mikrofon",
        "charging": "Złącze ładowania"
      },
      "validation": {
        "minModelsTitle": "Nieosiągnięto minimalnej liczby ekranów",
        "minModelsBody": "Ze względów logistycznych wymagamy minimum 15 ekranów na jedną wysyłkę. Dodaj proszę kilka dodatkowych sztuk do koszyka przed kontynuacją.",
        "minModelsCta": "Kontynuuj"
      },
      "expertise": {
        "dialogTitle": "Uzupełnij informacje o wysyłce",
        "dialogSubtitle": "Te dane pomagają nam przygotować list przewozowy (liczba paczek, szacowana waga itp.).",
        "piecesLabel": "Przybliżona liczba sztuk",
        "piecesPlaceholder": "Np. 120",
        "weightKgLabel": "Przybliżona waga (kg)",
        "weightKgPlaceholder": "Np. 18",
        "parcelsLabel": "Liczba paczek",
        "parcelsPlaceholder": "Np. 2",
        "minPiecesHint": "Ze względów logistycznych wymagane jest minimum 15 ekranów na jedną wysyłkę.",
        "weightHint": "Wskazówka: podziel ekrany na kilka paczek, jeśli zbliżasz się do 30 kg.",
        "globalHelper": "Ze względów logistycznych zalecamy maksymalnie 30 kg na paczkę. Podaj tylko wartości orientacyjne — doprecyzujemy je przy generowaniu listu przewozowego.",
        "cancel": "Wróć",
        "confirm": "Zapisz i kontynuuj"
      }
    }
  },
  "es": {
    "recap": {
      "title": "Resumen",
      "brand": {
        "other": "otro"
      },
      "count": {
        "devices": "Dispositivos",
        "parts": "Piezas de repuesto",
        "totalItems": "Total de piezas"
      },
      "total": "Total",
      "actions": {
        "validate": "Validar",
        "viewDetail": "Ver detalles",
        "clear": "Vaciar carrito",
        "removeSelection": "Eliminar selección",
        "close": "Cerrar"
      },
      "detail": {
        "title": "Detalles del carrito",
        "empty": "Ningún artículo.",
        "aria": "detalles del carrito"
      },
      "table": {
        "article": "Artículo",
        "unitPrice": "PU (€)",
        "qty": "Cant.",
        "total": "Total (€)"
      },
      "kind": {
        "device": "Dispositivo completo",
        "part": "Pieza de repuesto"
      },
      "labels": {
        "screen": "Pantalla",
        "part": "Pieza",
        "battery": "Batería",
        "camera": "Cámara",
        "speaker": "Altavoz",
        "microphone": "Micrófono",
        "chargingConnector": "Conector de carga",
        "button": "Botón",
        "vibrator": "Vibrador",
        "micro": "Micrófono",
        "charging": "Conector de carga"
      },
      "validation": {
        "minModelsTitle": "Cantidad mínima de pantallas no alcanzada",
        "minModelsBody": "Por razones logísticas, se requiere un mínimo de 15 pantallas por envío. Añade algunas piezas adicionales a tu carrito antes de continuar.",
        "minModelsCta": "Continuar"
      },
      "expertise": {
        "dialogTitle": "Precisa los detalles de tu envío",
        "dialogSubtitle": "Esta información nos ayuda a preparar tu etiqueta de envío (número de paquetes, peso estimado, etc.).",
        "piecesLabel": "Número aproximado de piezas",
        "piecesPlaceholder": "Ej. 120",
        "weightKgLabel": "Peso aproximado (kg)",
        "weightKgPlaceholder": "Ej. 18",
        "parcelsLabel": "Número de paquetes",
        "parcelsPlaceholder": "Ej. 2",
        "minPiecesHint": "Por razones logísticas, se requiere un mínimo de 15 pantallas por envío.",
        "weightHint": "Consejo: reparte tus pantallas en varios paquetes si te acercas a los 30 kg.",
        "globalHelper": "Por razones logísticas recomendamos un máximo de 30 kg por paquete. Indica solo una estimación; la ajustaremos si es necesario al generar la etiqueta.",
        "cancel": "Volver",
        "confirm": "Validar y continuar"
      }
    }
  },
  "it": {
    "recap": {
      "title": "Sintesi",
      "brand": {
        "other": "altri"
      },
      "count": {
        "devices": "Apparecchi",
        "parts": "Ricambi",
        "totalItems": "Totale articoli"
      },
      "total": "Totale",
      "actions": {
        "validate": "Convalida",
        "viewDetail": "Visualizza dettagli",
        "clear": "Carrello trasparente",
        "removeSelection": "Rimuovi la selezione",
        "close": "Chiudi"
      },
      "detail": {
        "title": "Dettagli del carrello",
        "empty": "Niente articoli.",
        "aria": "dettagli carrello"
      },
      "table": {
        "article": "Articolo",
        "unitPrice": "Unità (€)",
        "qty": "Qty",
        "total": "Totale"
      },
      "kind": {
        "device": "Dispositivo completo",
        "part": "Ricambio"
      },
      "labels": {
        "screen": "Schermo",
        "part": "Parte",
        "battery": "Batteria",
        "camera": "Macchina fotografica",
        "speaker": "Presidente",
        "microphone": "Microfono",
        "chargingConnector": "Connettore di ricarica",
        "button": "Pulsante",
        "vibrator": "Vibratore",
        "micro": "Microfono",
        "charging": "Connettore di ricarica"
      },
      "validation": {
        "minModelsTitle": "Quantità minima dello schermo non raggiunta",
        "minModelsBody": "Per motivi logistici è richiesto un minimo di 15 schermi per spedizione. Si prega di aggiungere altri elementi al carrello prima di procedere.",
        "minModelsCta": "Continua"
      },
      "expertise": {
        "dialogTitle": "Aggiungi dettagli sulla tua spedizione",
        "dialogSubtitle": "Queste informazioni ci aiutano a preparare la vostra etichetta di spedizione (numero di pacchi, peso stimato, ecc.).",
        "piecesLabel": "Numero approssimativo di articoli",
        "piecesPlaceholder": "es. 120",
        "weightKgLabel": "Peso approssimativo (kg)",
        "weightKgPlaceholder": "es. 18",
        "parcelsLabel": "Numero di pacchi",
        "parcelsPlaceholder": "es. 2",
        "minPiecesHint": "Per motivi logistici è richiesto un minimo di 15 schermi per spedizione.",
        "weightHint": "Suggerimento: dividere gli schermi in più pacchi se si è vicini a 30 kg.",
        "globalHelper": "Per ragioni logistiche, consigliamo un massimo di 30 kg per pacco. Basta fornire una stima; lo regolaremo se necessario quando si genera l'etichetta.",
        "cancel": "Indietro",
        "confirm": "Salvare e continuare"
      }
    }
  },
  "de": {
    "recap": {
      "title": "Zusammenfassung",
      "brand": {
        "other": "andere"
      },
      "count": {
        "devices": "Geräte",
        "parts": "Ersatzteile",
        "totalItems": "Summe der Posten"
      },
      "total": "Insgesamt",
      "actions": {
        "validate": "Validat",
        "viewDetail": "Angaben zur Darstellung",
        "clear": "Klarer Warenkorb",
        "removeSelection": "Auswahl entfernen",
        "close": "Schließen"
      },
      "detail": {
        "title": "Angaben zum Warenkorb",
        "empty": "Keine Artikel.",
        "aria": "Angaben zum Warenkorb"
      },
      "table": {
        "article": "Position",
        "unitPrice": "Einheit (€)",
        "qty": "Qty",
        "total": "Gesamt (€)"
      },
      "kind": {
        "device": "Vollständiges Gerät",
        "part": "Ersatzteil"
      },
      "labels": {
        "screen": "Bildschirm",
        "part": "Teil",
        "battery": "Batterie",
        "camera": "Kamera",
        "speaker": "Sprecher",
        "microphone": "Mikrofon",
        "chargingConnector": "Ladeanschluss",
        "button": "Button",
        "vibrator": "Vibrator",
        "micro": "Mikrofon",
        "charging": "Ladeanschluss"
      },
      "validation": {
        "minModelsTitle": "Mindestbildschirmmenge nicht erreicht",
        "minModelsBody": "Aus logistischen Gründen sind pro Sendung mindestens 15 Bildschirme erforderlich. Bitte fügen Sie ein paar weitere Artikel in Ihren Warenkorb, bevor Sie fortfahren.",
        "minModelsCta": "Weiterfahren"
      },
      "expertise": {
        "dialogTitle": "Details zu Ihrer Sendung hinzufügen",
        "dialogSubtitle": "Diese Informationen helfen uns, Ihr Versandetikett (Anzahl der Pakete, geschätztes Gewicht usw.) vorzubereiten.",
        "piecesLabel": "Ungefähre Anzahl der Positionen",
        "piecesPlaceholder": "z. B. 120",
        "weightKgLabel": "Ungefähres Gewicht (kg)",
        "weightKgPlaceholder": "z.B. 18",
        "parcelsLabel": "Anzahl der Parzellen",
        "parcelsPlaceholder": "z. B. 2",
        "minPiecesHint": "Aus logistischen Gründen sind pro Sendung mindestens 15 Bildschirme erforderlich.",
        "weightHint": "Tipp: Teilen Sie Ihre Bildschirme in mehrere Pakete, wenn Sie fast 30 kg sind.",
        "globalHelper": "Aus logistischen Gründen empfehlen wir maximal 30 kg pro Paket. Geben Sie einfach eine Schätzung an; wir passen sie bei Bedarf an, wenn Sie das Etikett generieren.",
        "cancel": "Rücken",
        "confirm": "Save und Continue"
      }
    }
  },
  "pt": {
    "recap": {
      "title": "Resumo",
      "brand": {
        "other": "outros"
      },
      "count": {
        "devices": "Dispositivos",
        "parts": "Peças sobressalentes",
        "totalItems": "Total das rubricas"
      },
      "total": "Total",
      "actions": {
        "validate": "Validar",
        "viewDetail": "Ver detalhes",
        "clear": "Limpar o carrinho",
        "removeSelection": "Remover a selecção",
        "close": "Fechar"
      },
      "detail": {
        "title": "Detalhes do carrinho",
        "empty": "Nada de itens.",
        "aria": "detalhes do carrinho"
      },
      "table": {
        "article": "Item",
        "unitPrice": "Unidade (€)",
        "qty": "Qty",
        "total": "Total (€)"
      },
      "kind": {
        "device": "Dispositivo completo",
        "part": "Peças sobresselentes"
      },
      "labels": {
        "screen": "Ecrã",
        "part": "Parte",
        "battery": "Bateria",
        "camera": "Câmera",
        "speaker": "Alto-falante",
        "microphone": "Microfone",
        "chargingConnector": "Conector de carregamento",
        "button": "Sabor",
        "vibrator": "Vibrações motoras",
        "micro": "Microfone",
        "charging": "Conector de carregamento"
      },
      "validation": {
        "minModelsTitle": "Quantidade mínima do ecrã não atingida",
        "minModelsBody": "Por razões logísticas, é necessário um mínimo de 15 ecrãs por remessa. Por favor adicione mais alguns itens ao seu carrinho antes de prosseguir.",
        "minModelsCta": "Continuar"
      },
      "expertise": {
        "dialogTitle": "Adicionar detalhes sobre o seu envio",
        "dialogSubtitle": "Esta informação ajuda-nos a preparar o seu rótulo de envio (número de encomendas, peso estimado, etc.).",
        "piecesLabel": "Número aproximado de itens",
        "piecesPlaceholder": "Por exemplo, 120",
        "weightKgLabel": "Peso aproximado (kg)",
        "weightKgPlaceholder": "Por exemplo, 18",
        "parcelsLabel": "Número de parcelas",
        "parcelsPlaceholder": "Por exemplo, 2",
        "minPiecesHint": "Por razões logísticas, é necessário um mínimo de 15 ecrãs por remessa.",
        "weightHint": "Dica: dividir suas ecrãs em várias parcelas se você estiver perto de 30 kg.",
        "globalHelper": "Por razões logísticas, recomendamos um máximo de 30 kg por parcela. Basta fornecer uma estimativa; vamos ajustá-la se necessário ao gerar o rótulo.",
        "cancel": "Voltar",
        "confirm": "Salvar e continuar"
      }
    }
  },
  "cs": {
    "recap": {
      "title": "Shrnutí",
      "brand": {
        "other": "ostatní"
      },
      "count": {
        "devices": "Zařízení",
        "parts": "Náhradní díly",
        "totalItems": "Položky celkem"
      },
      "total": "Celkem",
      "actions": {
        "validate": "Potvrdit",
        "viewDetail": "Zobrazit detaily",
        "clear": "Uvolnit košík",
        "removeSelection": "Odstranit výběr",
        "close": "Zavřít"
      },
      "detail": {
        "title": "Podrobnosti o vozíku",
        "empty": "Žádné položky.",
        "aria": "údaje o vozíku"
      },
      "table": {
        "article": "Položka",
        "unitPrice": "Jednotka (€)",
        "qty": "Qty",
        "total": "Celkem (v EUR)"
      },
      "kind": {
        "device": "Kompletní zařízení",
        "part": "Náhradní část"
      },
      "labels": {
        "screen": "Obrazovka",
        "part": "Část",
        "battery": "Baterie",
        "camera": "Kamera",
        "speaker": "Mluvčí",
        "microphone": "Mikrofon",
        "chargingConnector": "Nabíjecí konektor",
        "button": "Chuť",
        "vibrator": "Vibrationsmotor",
        "micro": "Mikrofon",
        "charging": "Nabíjecí konektor"
      },
      "validation": {
        "minModelsTitle": "Minimální množství na obrazovce nedosaženo",
        "minModelsBody": "Z logistických důvodů je vyžadováno minimálně 15 obrazovek na jednu zásilku. Před pokračováním přidejte do košíku několik dalších položek.",
        "minModelsCta": "Pokračovat"
      },
      "expertise": {
        "dialogTitle": "Přidat podrobnosti o vaší zásilce",
        "dialogSubtitle": "Tyto informace nám pomohou připravit vaši přepravní značku (počet balíků, odhadovaná hmotnost atd.).",
        "piecesLabel": "Přibližný počet položek",
        "piecesPlaceholder": "např. 120",
        "weightKgLabel": "Přibližná hmotnost (kg)",
        "weightKgPlaceholder": "např. 18",
        "parcelsLabel": "Počet parcel",
        "parcelsPlaceholder": "např. 2",
        "minPiecesHint": "Z logistických důvodů je vyžadováno minimálně 15 obrazovek na jednu zásilku.",
        "weightHint": "Tip: pokud se blížíte 30 kg, rozdělte obrazovky na více balíčků.",
        "globalHelper": "Z logistických důvodů doporučujeme maximálně 30 kg na zásilku. Jen nám poskytněte odhad; v případě potřeby jej přizpůsobíme při generování štítku.",
        "cancel": "Zpět",
        "confirm": "Uložit a pokračovat"
      }
    }
  },
  "nl": {
    "recap": {
      "title": "Samenvatting",
      "brand": {
        "other": "Andere"
      },
      "count": {
        "devices": "Apparaten",
        "parts": "Onderdelen",
        "totalItems": "Totaal posten"
      },
      "total": "Totaal",
      "actions": {
        "validate": "Valideren",
        "viewDetail": "Details weergeven",
        "clear": "Winkelwagen wissen",
        "removeSelection": "Selectie verwijderen",
        "close": "Sluiten"
      },
      "detail": {
        "title": "Cart details",
        "empty": "Geen items.",
        "aria": "cart details"
      },
      "table": {
        "article": "Post",
        "unitPrice": "Eenheid (€)",
        "qty": "Aantal",
        "total": "Totaal (€)"
      },
      "kind": {
        "device": "Compleet apparaat",
        "part": "Reserveonderdeel"
      },
      "labels": {
        "screen": "Scherm",
        "part": "Deel",
        "battery": "Batterij",
        "camera": "Camera",
        "speaker": "Speaker",
        "microphone": "Microfoon",
        "chargingConnector": "Oplaadconnector",
        "button": "Proef",
        "vibrator": "Trillingsmotor",
        "micro": "Microfoon",
        "charging": "Oplaadconnector"
      },
      "validation": {
        "minModelsTitle": "Minimale schermhoeveelheid niet bereikt",
        "minModelsBody": "Om logistieke redenen is een minimum van 15 schermen per zending vereist. Voeg nog een paar artikelen toe aan uw winkelmandje voordat u verder gaat.",
        "minModelsCta": "Doorgaan"
      },
      "expertise": {
        "dialogTitle": "Voeg details toe over uw zending",
        "dialogSubtitle": "Deze informatie helpt ons bij het voorbereiden van uw verzendlabel (aantal pakketten, geschat gewicht, enz.).",
        "piecesLabel": "Geschat aantal posten",
        "piecesPlaceholder": "bv. 120",
        "weightKgLabel": "Geschat gewicht (kg)",
        "weightKgPlaceholder": "bv. 18",
        "parcelsLabel": "Aantal percelen",
        "parcelsPlaceholder": "bv. 2",
        "minPiecesHint": "Om logistieke redenen is een minimum van 15 schermen per zending vereist.",
        "weightHint": "Tip: split uw schermen in meerdere pakketten als u dicht bij 30 kg.",
        "globalHelper": "Om logistieke redenen raden wij maximaal 30 kg per pakket aan. Geef gewoon een schatting; we zullen aanpassen indien nodig bij het genereren van het label.",
        "cancel": "Terug",
        "confirm": "Opslaan en doorgaan"
      }
    }
  }
};

export default recapI18n;
